module.exports = __webpack_public_path__ + "img/convenioSindical3.d1875fc3.jpg";